import axiosClient from './axiosClient';

export const getTabletopsForCompany = companyId => {
    return axiosClient.get(`/report/tabletop/company/${companyId}`, {responseType: 'arraybuffer'});
}
